import { useQueryClient } from '@tanstack/react-query';
import { trackError } from '@proposify/frontend-observability';
import { QueryKeys } from 'utils/queryKeys';

export const useInvalidateApprovalQueries = (module: string) => {
  const queryClient = useQueryClient();

  return async (contentId: string) => {
    try {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: QueryKeys.getDocumentApprovalStateBase(contentId),
        }),
        queryClient.invalidateQueries({
          queryKey: QueryKeys.getDocumentMetadataByContentId(contentId),
        }),
      ]);
    } catch (error) {
      trackError(new Error(`${module}: failed to invalidate approval queries`, { cause: error }), {
        tags: { module },
        extra: { contentId },
      });
    }
  };
};
